import { motion } from "framer-motion";
import { CheckCircle, ArrowUpRight } from "@phosphor-icons/react";
import { IMG, SERVICES } from "../data/content";
import { Reveal } from "../lib/motion";
import { Btn } from "../components/Btn";
import ContactCTA from "../components/ContactCTA";

const SERVICE_IMG = [IMG.meeting, IMG.hero, IMG.construction, IMG.apartment, IMG.hvac, IMG.hero];

export default function Diensten() {
  return (
    <div data-testid="diensten-page">
      <section className="pt-40 pb-16">
        <div className="container-ballk max-w-4xl">
          <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="eyebrow mb-5">Diensten</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
            className="font-heading font-bold text-ballk-indigo text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Complete begeleiding, van eerste schets tot oplevering.
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-6 text-ballk-steel text-lg max-w-2xl leading-relaxed">
            Zes specialismen die naadloos samenkomen in overzicht, vertrouwen en resultaat.
          </motion.p>
        </div>
      </section>

      {SERVICES.map((s, i) => (
        <section key={s.slug} data-testid={`dienst-block-${s.slug}`}
          className={`py-16 md:py-24 ${i % 2 === 1 ? "bg-[#FAFAFB] border-y border-ballk-light" : ""}`}>
          <div className="container-ballk grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
              <div className="overflow-hidden rounded-[20px] diag-img">
                <img src={SERVICE_IMG[i]} alt={s.title} className="w-full h-[360px] md:h-[440px] object-cover" />
              </div>
            </Reveal>
            <div className={i % 2 === 1 ? "lg:order-1" : ""}>
              <Reveal>
                <div className="h-14 w-14 rounded-xl bg-ballk-purple/10 flex items-center justify-center text-ballk-purple mb-6"><s.icon size={28} weight="duotone" /></div>
                <p className="eyebrow mb-3">0{i + 1} — Dienst</p>
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-ballk-indigo tracking-tight">{s.title}</h2>
                <p className="mt-5 text-ballk-steel text-lg leading-relaxed">{s.desc}</p>
                <ul className="mt-7 space-y-3">
                  {s.benefits.map((b) => (
                    <li key={b} className="flex items-center gap-3 text-ballk-indigo font-medium">
                      <CheckCircle size={20} weight="fill" className="text-ballk-purple shrink-0" /> {b}
                    </li>
                  ))}
                </ul>
                <Btn to="/contact" variant="secondary" className="mt-8">Vraag advies <ArrowUpRight size={16} weight="bold" /></Btn>
              </Reveal>
            </div>
          </div>
        </section>
      ))}

      <ContactCTA />
    </div>
  );
}
